<!--
    课程中心-课程详情
    功能：课程详情数据
    说明：旧版本
-->
<template>
  <div
    v-loading="loading"
    class="detail">
    <el-link
      :underline="false"
      class="app-webview-back"
      @click="$router.go(-1)"
    >
      <i class="el-icon-arrow-left"/>
      {{ $route.matched[1].meta.title }}
    </el-link>

    <dl class="detail-head flex">
      <dt
        v-if="list.video"
        class="fn pr"
        @click="showVideo(list.name, list.video, true)">
        <img :src="cover || noCover">
        <div class="btn-video"/>
      </dt>
      <dt
        v-else
        class="fn pr">
        <img :src="cover || noCover">
      </dt>
      <dd class="fg">
        <h3>{{ list.name }}</h3>
        <div class="flex jb w600">
          <div class="flex"><span class="gray">制作方：</span><p class="elps">{{ detail.company_name }}</p></div>
          <p><span class="gray">上线时间：</span>{{ list.publish_time }}</p>
          <p><span class="gray">课时数量：</span>{{ list.course_count }}课时</p>
        </div>
        <dl class="head-price iflex ac ja">
          <dd>
            <p class="gray">线下课时单价（/课时/次）</p>
            <div class="flex jb">
              <div><span>原价：</span>{{ list.offline_price }}金币</div>
              <p class="flex"><span class="gray">优惠价：</span><strong>{{ list.offline_discount_price }}金币</strong></p>
            </div>
          </dd>
          <dt/>
          <dd>
            <p class="gray">线上课时单价（/课时/学生/次）</p>
            <div class="flex jb">
              <div><span>原价：</span>{{ list.online_price }}金币</div>
              <p class="flex"><span class="gray">优惠价：</span><strong>{{ list.online_discount_price }}金币</strong></p>
            </div>
          </dd>
        </dl>
      </dd>
    </dl>
    <div class="detail-introduce">
      <h4>课程介绍</h4>
      <div class="introduce-con">
        <p>{{ introduce_status.show ? list.introduction : introduce_status.short }}<a
          v-if="introduce_status.short"
          @click="introduce_status.show = !introduce_status.show">{{ introduce_status.show ? '收起' : '展开' }}详情 ></a></p>
      </div>
    </div>
    <div class="detail-introduce">
      <h4>课程详情</h4>
      <div class="introduce-con">
        <div class="detail-slide">
          <div
            ref="detail_p"
            :class="{'detail-hide': detailP.can && !detailP.show}"
            class="detail-con"
            v-html="list.detail"/>
          <a
            v-if="detailP.can"
            style="margin: 0;"
            @click="detailP.show = !detailP.show">{{ detailP.show ? '收起' : '展开' }}详情 ></a>
        </div>
      </div>
    </div>
    <!--    <div class="detail-class">-->
    <!--      <div class="flex ac">-->
    <!--        <h4>课时：</h4>-->
    <!--        <el-radio-group v-if="classData.list.length" v-model="classData.model" @change="classChange">-->
    <!--          <el-radio v-for="(item, index) in classData.list" :key="index" :label="item.label">{{item.text}}</el-radio>-->
    <!--        </el-radio-group>-->
    <!--        <span v-else>{{classData.state}}</span>-->
    <!--      </div>-->
    <!--      <div>-->
    <!--        <ul class="class-ul flex fw" :class="{show: classData.model === item.label, 'no-check': from_goods}" v-for="(item, index) in classData.list" :key="index">-->
    <!--          <li v-for="(itm, indx) in item.list" class="fn" :class="{check: classData.check.id === itm.id && classData.check.index === classData.step * index + indx}" @click="checkItem(Object.assign(itm, {index: classData.step * index + indx}))">-->
    <!--            <div class="class-head pr">-->
    <!--              <img :src="itm.image || itm.cover || noCover" @error="itm.cover = noCover">-->
    <!--              <span>{{1 + classData.step * index + indx}}</span>-->
    <!--              <div v-if="from_goods && (classData.step * index + indx < 2)" class="btn-video" @click.stop="showIframe(itm)"></div>-->
    <!--            </div>-->
    <!--            <p class="class-foot elps">{{itm.name}}</p>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="detail-class">
      <div class="flex ac">
        <h4>课时：</h4>
        <template v-if="!typeSelectHide">
          <TypeSelect
            :root-catalog="'校区分类'"
            :data.sync="typeSelectDataMe"
            :select-list="typeSelectList"
            type="commodity_course_category"
            @onTypeSelect="onTypeSelect"
          />
        </template>
      </div>
      <div>
        <ul
          v-if="classData.show"
          :class="{'no-check': from_goods}"
          class="class-ul flex fw"
        >
          <li
            v-for="(item, index) in classData.list"
            :key="index"
            :class="{check: classData.check.id === item.id && classData.check.index === index, 'is-hide': item.hide}"
            class="fn"
            @click="checkItem(Object.assign(item, {index: index}))"
          >
            <div class="class-head pr">
              <img
                :src="item.image || item.cover || noCover"
                @error="item.cover = noCover">
              <span>{{ 1 + index }}</span>
              <div
                v-if="from_goods && (index < 2)"
                class="btn-video"
                @click.stop="showIframe(item)"/>
            </div>
            <p class="class-foot elps">{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="!isLive"
      class="detail-foot flex jc">
      <el-button
        v-if="from_goods"
        type="primary"
        @click="classBuy">购 买</el-button>
      <template v-else>
        <el-button @click="classSee">预 览</el-button>
        <el-button
          v-if="$permissions('school_goods_course')"
          type="primary"
          @click="classGo">上 课</el-button>
      </template>
      <el-button
        v-if="$permissions('school_goods_download')&&isFromGoods"
        type="default"
        @click="downLoad">下载</el-button>
      <el-button
        v-if="$permissions('school_goods_buy_download')&&!isFromGoods"
        type="default"
        @click="downLoad">下载</el-button>
    </div>

    <el-dialog
      :title="videoData.title"
      :visible.sync="videoData.show"
      class="dialog-sp1 dialog-video"
      width="692px"
      @opened="videoOpen"
      @close="videoClose">
      <video
        ref="ref_video"
        :src="videoData.src"
        controls="controls"
        width="100%"/>
    </el-dialog>

    <el-dialog
      :visible.sync="iframeData.show"
      :title="iframeData.title"
      class="dialog-sp1 dialog-video"
      width="692px">
      <iframe
        v-if="iframeData.show"
        id="iframe"
        :src="iframeData.src"
        frameborder="0"
        width="100%"
        style="display: block;"
        height="389.25px"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="iframe2Data.show"
      :title="iframe2Data.title"
      class="dialog-sp1 dialog-video"
      width="692px">
      <iframe
        v-if="iframe2Data.show"
        id="iframe"
        :src="iframe2Data.src"
        frameborder="0"
        width="100%"
        style="display: block;"
        height="389.25px"
      />
    </el-dialog>

    <el-dialog
      :visible.sync="isNoNum"
      title="提示"
      class="dialog-sp1 dialog-video"
      style="text-align: center;"
      width="300px">
      <el-row style="margin-top: 20px;">当前课包使用次数为0</el-row>
      <el-button
        style="margin: 20px 0;"
        type="primary"
        @click="getBuy"
      >去购买</el-button>
    </el-dialog>
    <package-status
      v-if="isPackageStatus"
      :visible.sync="isPackageStatus"
      :form.sync="packageItem"
      :rate.sync="packageRate"
      @success="successPackageStatus"
    />
  </div>
</template>

<script>
import index from './';

export default index;
</script>

<style scoped lang="scss">
  @import '../../../assets/reset.scss';
  @import "index.scss";

  .is-hide {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Goods/ClassDetail/index.vue